export const CLIENT_OPTIONS = [
  { label: '全部客户端', value: 'ALL' },
  { label: '微信小程序', value: 'MP-WEIXIN' },
  { label: '鸿蒙元服务', value: 'MP-HARMONY' },
  { label: 'App', value: 'APP-PLUS' },
  { label: 'H5', value: 'H5' }
]

export const PAGE_ACTION_OPTIONS = [
  { label: '页面路由', value: 'route' },
  { label: '底部导航', value: 'tab' },
  { label: '网页链接', value: 'web' },
  { label: '提示文案', value: 'toast' }
]

export const BUSINESS_OPTIONS = [
  { label: '节日专区自营', value: 'festival', hint: '商品资料、库存和订单均由节日专区独立管理' }
]

export function action(type = 'toast', value = '') {
  return { type, value, message: '' }
}

export function image(src = '', alt = '') {
  return { src, alt }
}

export function createDefaultConfig() {
  return {
    enabled: true,
    themeId: 'mid-autumn-2026',
    theme: { primaryColor: '#cf2f23', secondaryColor: '#f27842', textColor: '#fff2d3' },
    hero: {
      image: image('/static/festival/mid-autumn/hero-art.png', '中秋夜景'),
      titleTop: '中秋团圆',
      titleBottom: '乐购好礼',
      ribbon: '月满中秋 · 限时好礼',
      slogan: '好物寄相思　团圆更美好',
      blessing: '但愿人长久\n千里共婵娟'
    },
    countdown: {
      label: '距离活动结束还有',
      endAt: '2026-09-27T23:59:59+08:00',
      actionText: '查看活动规则',
      action: action('rules'),
      rulesTitle: '中秋活动规则',
      rules: [
        '活动商品及服务数量有限，售完即止。',
        '优惠券领取和使用范围以券面说明为准。',
        '活动展示内容以后续后台发布的实时配置为准。'
      ]
    },
    categories: {
      items: [
        { id: 'gift', title: '中秋礼盒', iconText: '🥮', image: image(), action: action('route', '/pages/activity/festival-category?categoryId=gift') },
        { id: 'fruit', title: '应季鲜果', iconText: '果', image: image(), action: action('route', '/pages/activity/festival-category?categoryId=fruit') },
        { id: 'home', title: '节日家居', iconText: '家', image: image(), action: action('route', '/pages/activity/festival-category?categoryId=home') },
        { id: 'all', title: '全部商品', iconText: '✣', image: image(), action: action('route', '/pages/activity/festival-category') }
      ]
    },
    recommendation: {
      title: '限时推荐',
      subtitle: '月圆好物 · 把团圆带回家',
      productIds: [],
      products: [],
      moreAction: action('route', '/pages/activity/festival-category')
    },
    coupon: {
      image: image('/static/festival/mid-autumn/coupon-banner.png', '中秋专属优惠券'),
      action: action('route', '/pages/mine/coupon')
    }
  }
}

export function mergeConfig(base, source) {
  if (Array.isArray(base)) return Array.isArray(source) ? source : base
  if (!base || typeof base !== 'object' || !source || typeof source !== 'object') {
    return source === undefined || source === null ? base : source
  }
  const merged = { ...base }
  Object.keys(source).forEach(key => {
    merged[key] = Object.prototype.hasOwnProperty.call(base, key)
      ? mergeConfig(base[key], source[key])
      : source[key]
  })
  return merged
}

export function normalizePageConfig(source) {
  const config = mergeConfig(createDefaultConfig(), source || {})
  config.categories.items = (config.categories.items || []).map((item, index) => ({
    ...item,
    id: item.id || `category-${index + 1}`,
    image: item.image || image(),
    action: item.action || action()
  }))
  config.recommendation.productIds = config.recommendation.productIds || []
  return config
}

export function emptyProduct() {
  return {
    productId: '',
    categoryId: '',
    title: '',
    subtitle: '',
    badge: '限时特惠',
    imageUrl: '',
    salePrice: '',
    originalPrice: '',
    actionType: 'festival',
    unit: '份',
    detail: '',
    stock: 1,
    enabled: true,
    sort: 0
  }
}

export function parseProductForm(row) {
  if (!row) return emptyProduct()
  return {
    ...emptyProduct(),
    ...row,
    actionType: 'festival',
    enabled: row.enabled === 'Y' || row.enabled === true
  }
}

export function businessLabel(type) {
  const option = BUSINESS_OPTIONS.find(item => item.value === type)
  if (option) return option.label
  return '节日专区自营'
}

export function businessHint() {
  return BUSINESS_OPTIONS[0].hint
}

export function isJumpableProduct(row) {
  return Number(row && row.stock) > 0
    && (row.enabled === 'Y' || row.enabled === true)
}

function parseTime(value) {
  if (!value) return 0
  const text = String(value).trim()
  const time = Date.parse(text.includes('T') ? text : text.replace(' ', 'T'))
  return Number.isNaN(time) ? 0 : time
}

export function campaignStatus(row) {
  const enabled = row && (row.enabled === 'Y' || row.enabled === true)
  const version = Number(row && row.version || 0)
  const published = row && row.published && Object.keys(row.published).length
  const start = parseTime(row && row.startTime)
  const end = parseTime(row && row.endTime)
  const now = Date.now()
  if (!enabled) return { code: 'OFFLINE', label: '已关闭', type: 'info' }
  if (!version && !published) return { code: 'UNPUBLISHED', label: '未发布', type: 'warning' }
  if (start && now < start) return { code: 'UPCOMING', label: '未开始', type: 'warning' }
  if (end && now > end) return { code: 'ENDED', label: '已结束', type: 'danger' }
  return { code: 'ACTIVE', label: '进行中', type: 'success' }
}

export function clientTypeLabel(clientType) {
  const option = CLIENT_OPTIONS.find(item => item.value === clientType)
  return option ? option.label : clientType
}

export function themeCssVars(theme) {
  const current = theme || {}
  return {
    '--fe-primary': current.primaryColor || '#cf2f23',
    '--fe-secondary': current.secondaryColor || '#f27842',
    '--fe-text': current.textColor || '#fff2d3'
  }
}

export function heroBackgroundStyle(theme, imageUrl) {
  const primary = (theme && theme.primaryColor) || '#cf2f23'
  const secondary = (theme && theme.secondaryColor) || '#f27842'
  if (imageUrl) {
    return {
      backgroundColor: primary,
      backgroundImage: `linear-gradient(180deg, rgba(0,0,0,.06), rgba(0,0,0,.28)), url(${imageUrl})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }
  }
  return {
    backgroundImage: `linear-gradient(165deg, ${primary} 0%, ${secondary} 100%)`
  }
}

export function countdownParts(endAt, now) {
  const raw = String(endAt || '').trim()
  const stamp = Date.parse(raw.includes('T') || raw.includes(' ') ? raw.replace(' ', 'T') : raw)
  const left = Math.max(0, (Number.isNaN(stamp) ? 0 : stamp) - (now || Date.now()))
  const pad = value => String(value).padStart(2, '0')
  return {
    days: pad(Math.floor(left / 86400000)),
    hours: pad(Math.floor(left / 3600000) % 24),
    minutes: pad(Math.floor(left / 60000) % 60),
    seconds: pad(Math.floor(left / 1000) % 60)
  }
}
